import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import {
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Radio,
  RadioGroup,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@material-ui/core";
import { Redirect } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { useForm } from "../../../../hooks/useForm";
import { 
  cleanAfiliadoSeleccionadoAdicciones, 
  cleanSolicitudAdicciones, 
  getSolicitudesContadoresGestionAdicciones, 
  setEstadoSolicitudesAdicciones 
} from "../../../../actions/adicciones/adiccionesActions";
import { ESTADO_SOLICITUD_ADICCIONES } from "../../data/constants";
import { AutorizacionesBuscador } from "../../../autorizaciones/Ingreso/AutorizacionesBuscador";
import BuscadorPractica from "../../../turnos/coseguros/BuscadorPractica";
import { Search } from "@material-ui/icons";
import { SolicitudAdiccionesItem } from "./SolicitudAdiccionesItem";
import { validarSoloUnPermiso } from "../../../../helpers/permisos";
import { ADICCIONES_GESTION_PERMISOS } from "../../../../utils/permisos";

const useStyles = makeStyles({
  root: {
    padding: 10,
    flexGrow: 1,
    marginTop: -20,
    // width: "100%",
  },
  input: {
    // padding: 10,
    paddingLeft: 10,
    paddingRight: 10
  },
});

const stateInitial = {
  fechaFin: moment(),
  fechaInicio: moment().subtract(7, 'days'),
  idSolicitud: '',
  codigoPractica: null,
};

let arrayEstadosSolicitudes = [];

export function GestionAdiccionesHome(props) { 
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    estadoSolicitudes,
    solicitudes: items,
    afiliadoSeleccionado,
    solicitudesContadores,
  } = useSelector((state) => state.adicciones);

  const { permisos: permisosUser } = useSelector(
    (state) => state.auth
  );

  const [formValues, , , setearValor] = useForm(stateInitial);
  const {fechaInicio, fechaFin, idSolicitud, codigoPractica} = formValues;
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [redirect, setRedirect] = useState(false);
  const [dense, setDense] = useState(true);
  const [page, setPage] = useState(0);

  useEffect(() => {
    // if(!props.location.state?.fromHomeScreen){
      // dispatch( clearAdicciones() );
      dispatch( cleanSolicitudAdicciones() );
      dispatch( cleanAfiliadoSeleccionadoAdicciones() );
    // }
  }, [dispatch]);
  
  const tieneBandejaEnCarga =
      validarSoloUnPermiso(permisosUser,
        ADICCIONES_GESTION_PERMISOS.EN_CARGA);
    
    const tieneBandejaPendiente =
      validarSoloUnPermiso(permisosUser,
        ADICCIONES_GESTION_PERMISOS.PENDIENTE);
    
    const tieneBandejaPendienteAutorizacion =
      validarSoloUnPermiso(permisosUser,
        ADICCIONES_GESTION_PERMISOS.PENDIENTE_AUTORIZACION);

  useEffect(() => {
    arrayEstadosSolicitudes = Object.entries(ESTADO_SOLICITUD_ADICCIONES);

    const tieneBandejaEnCarga = true;
      // validarSoloUnPermiso(permisosUser,
      //   ADICCIONES_GESTION_PERMISOS.EN_CARGA);
    
    const tieneBandejaPendiente = true;
      // validarSoloUnPermiso(permisosUser,
      //   ADICCIONES_GESTION_PERMISOS.PENDIENTE);
    
    const tieneBandejaPendienteAutorizacion = true;
      // validarSoloUnPermiso(permisosUser,
      //   ADICCIONES_GESTION_PERMISOS.PENDIENTE_AUTORIZACION);
    
    arrayEstadosSolicitudes = arrayEstadosSolicitudes.filter(
      (estadoComprobante) =>
        (tieneBandejaEnCarga &&
          (estadoComprobante[1] ===
            ESTADO_SOLICITUD_ADICCIONES.EN_CARGA ||
          estadoComprobante[1] ===
          ESTADO_SOLICITUD_ADICCIONES.EN_CARGA_AFILIADO)) ||
        (tieneBandejaPendiente &&
          estadoComprobante[1] ===
          ESTADO_SOLICITUD_ADICCIONES.AUDITORIA_ADMINISTRATIVA) ||
        (tieneBandejaPendienteAutorizacion &&
          estadoComprobante[1] === 
          ESTADO_SOLICITUD_ADICCIONES.PENDIENTE_AUTORIZACION) ||        
        ( estadoComprobante[1] === ESTADO_SOLICITUD_ADICCIONES.RECHAZADA 
          || estadoComprobante[1] === ESTADO_SOLICITUD_ADICCIONES.CANCELADA
          || estadoComprobante[1] === ESTADO_SOLICITUD_ADICCIONES.AUTORIZADA)
    );

    // if(arrayEstadosSolicitudes.filter(s => s[1] === ESTADO_SOLICITUD_ADICCIONES.EN_CARGA).length > 0){
    //   dispatch(setEstadoSolicitudesAdicciones(ESTADO_SOLICITUD_ADICCIONES.EN_CARGA?.toString()));
    // }
  }, [permisosUser]);  

  useEffect(() => {
    buscarConParametros();
  }, [
    dispatch,
    afiliadoSeleccionado?.id_afiliado,
    codigoPractica,
    fechaInicio,
    fechaFin,
    estadoSolicitudes
  ]);

  const buscarConParametros = () => {
    dispatch(
      getSolicitudesContadoresGestionAdicciones(
        afiliadoSeleccionado?.id_afiliado,
        codigoPractica,
        idSolicitud,
        fechaInicio,
        fechaFin,
        estadoSolicitudes ? parseInt(estadoSolicitudes) : null,
      )
    );
    setPage(0);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const componentRef = React.useRef();

  return (
    <Grid container className={classes.root} justify="center" spacing={1}>
      <Grid item xs={12}>
        <Grid container direction="row" alignItems="center" spacing={1}>
          <Grid item xs={12} md={3}>
            <AutorizacionesBuscador 
              gestion={true} 
              hideTitle={true} 
              integracion={true} 
              tipoBusqueda={'Discapacitados'} 
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Grid
              container
              spacing={3}
              style={{ display: "flex", padding: 5 }}
            >
              <Grid item xs={12} md={12} >                
                <BuscadorPractica 
                  cod={codigoPractica} 
                  label="Código Practica" 
                  gestionAutorizacion={true}
                  integracion={true}
                  setCod={(val) => setearValor("codigoPractica", val)}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <TextField
                margin="normal"
                // InputProps={{ classes: { input: classes.NroAfi } }}
                fullWidth
                type='number'
                label="Id Solicitud"
                name="idSolicitud"
                value={idSolicitud}
                autoComplete="off"
                onChange={(e) => setearValor("idSolicitud", e.target.value)}
                onKeyUp={(e) => { if (e.key === 'Enter') buscarConParametros() }}
                InputProps={{
                  endAdornment:
                    <InputAdornment position="end" style={{marginTop: -25, marginRight: -10}}>
                      <IconButton
                        aria-label="Buscar"
                        onClick={buscarConParametros}
                      >
                        <Search />
                      </IconButton>
                    </InputAdornment>
                }}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  label="Fecha Inicio"
                  format="dd/MM/yyyy"
                  // required={true}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  value={
                    moment(fechaInicio).isValid() ? moment(fechaInicio) : null
                  }
                  onChange={(date) => {
                    setearValor("fechaInicio", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Paper>
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  label="Fecha Fin"
                  format="dd/MM/yyyy"
                  // required={true}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  value={moment(fechaFin).isValid() ? moment(fechaFin) : null}
                  onChange={(date) => {
                    setearValor("fechaFin", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Paper style={{ padding: "0.25rem" }}>
          <RadioGroup
            row
            style={{ justifyContent: "space-around" }}
            value={estadoSolicitudes}
            onChange={(e) => {
              dispatch(setEstadoSolicitudesAdicciones(e.target.value));
            }}
          >
            {Array.isArray(Object.entries(arrayEstadosSolicitudes)) &&
              Object.entries(arrayEstadosSolicitudes).map((item) => {                
              const contador = solicitudesContadores.find(s => s.idEstado === item[1][1]);
              const label =
                item[1][0].charAt(0) +
                item[1][0].replaceAll("_", " ").toLowerCase().slice(1) + 
                ((contador && contador !== undefined) 
                  ? 
                    `(${contador.total})`
                  :
                    `(...)`
                );
              return (
                <FormControlLabel
                  key={item[1][1]?.toString()}
                  style={{ marginLeft: "0.5rem" }}
                  label={label}
                  value={item[1][1]?.toString()}
                  control={<Radio />}
                />
              );
            })}
          </RadioGroup>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <TableContainer component={Paper} style={{ overflowX: "auto" }}>
          <Table size={dense ? "small" : "medium"} ref={componentRef}>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell align="left">Estado</TableCell>
                <TableCell align="left">Fecha</TableCell>
                <TableCell align="left">N° Orden</TableCell>
                {/*<TableCell align="left">Tipo Solicitud</TableCell>
                <TableCell align="left">SubTipo Solicitud</TableCell>*/}             
                <TableCell align="left">Diagnostico</TableCell>
                {/*<TableCell align="left"></TableCell> Prácticas */}
                <TableCell align="left">Prestador</TableCell>
                <TableCell align="left">Paciente</TableCell>
                <TableCell align="left">N° Afiliado</TableCell>
                <TableCell align="left">Tomada</TableCell>
                <TableCell align="left"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.length > 0 && (
                items.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item) => {                  
                  return (
                    <SolicitudAdiccionesItem
                      item={item}
                      key={item.idSolicitud}
                      setRedirect={setRedirect}
                      tieneBandejaEnCarga={tieneBandejaEnCarga}
                      tieneBandejaPendiente={tieneBandejaPendiente}
                      tieneBandejaPendienteAutorizacion={tieneBandejaPendienteAutorizacion}
                    />
                  );
                }))}                
                {items.length === 0 && (
                  <TableRow style={{ height: 50 }}>
                    <TableCell
                      colSpan={13}
                      style={{ textAlign: "-webkit-center" }}
                    >
                      {" "}
                      Sin Registros
                    </TableCell>
                  </TableRow>
                )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      {items.length > 0 && (
        <Grid item xs={12}>
          <TablePagination
            style={{ backgroundColor: "white" }}
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={items.length}
            rowsPerPage={rowsPerPage}
            labelRowsPerPage="Registros por página"
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
          <FormControlLabel
            control={
              <Switch
                checked={dense}
                onChange={(e) => setDense(e.target.checked)}
              />
            }
            label="Tamaño compacto"
          />
        </Grid>
      )}
      {redirect && (
        <Redirect
          to={{
            pathname: '/adicciones/home',
            state: {
              from: '/adicciones/gestion'
            },
          }}
        />
      )}
    </Grid>
  );
};